import {motion} from "framer-motion";
import {FC} from "react";
import {CustomPageHeader} from "../CustomPageHeader.tsx";
import {CustomSelect} from "../CustomSelect.tsx";
import {TextFieldCustom} from "../TextFieldCustom.tsx";
import {ButtonsBottomBlockOfPage} from "../ButtonsBottomBlockOfPage.tsx";
import {Button} from "../../ui-components/button.tsx";
import {FormikProvider, useFormik} from "formik";
import {useTranslation} from "react-i18next";
import {formatDateForApi} from "../../dateUtils/dateUtils.ts";
import {ParamsRefStatsData} from "../../state/models/UserResponse.ts";

interface ModalProps {
    onClose: () => void;
    applyFilters?: (payload: ParamsRefStatsData) => void;
}


export const StatsFilterModal: FC<ModalProps> = ({onClose, applyFilters}) => {
    const now = new Date();
    const endDate = new Date(now);
    endDate.setMonth(endDate.getMonth() - 1);
    const {t} = useTranslation();

    const periodArr = [
        {
            index: 0,
            title: t('form.selects.period.valueMonth'),
            value: "lastMonth",
        },
        {
            index: 1,
            title:  t('form.selects.period.valueALL'),
            value: "all",
        },
    ];

    const initialValues = {
        period: '',
        login: ''
    };

    const formik = useFormik({
        initialValues,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: async (values) => {
            const payload: ParamsRefStatsData = {
                page: 1,
                limit: 10,
            };

            if (values.login.trim()) {
                payload.login = values.login.trim();
            }

            if (values.period === 'lastMonth') {
                payload.start_date = formatDateForApi(endDate);
                payload.end_date = formatDateForApi(now);
            }

            try {
                applyFilters?.(payload); // ✅ используем переданный колбэк
                onClose();
            } catch (err) {
                console.error("Ошибка при фильтрации статистики:", err);
            }
        }
    });
    const resetValues = () => {
        formik.resetForm({})
    }
    return (
        <div
            className="absolute inset-0 z-[99999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
            onClick={onClose}
        >
            <motion.div
                className="w-full h-full bg-[var(--default-page-color)] flex flex-col"
                initial={{y: 50, opacity: 0, scale: 0.8}}
                animate={{y: 0, opacity: 1, scale: 1}}
                exit={{y: 50, opacity: 0, scale: 0.8}}
                transition={{duration: 0.3, ease: "easeInOut"}}
                onClick={(e) => e.stopPropagation()} // Остановить всплытие
            >
                <CustomPageHeader title={t('modals.referralStatsFilter.heading')} type={"BACK"} onClickBack={onClose}
                                  padding_xs={true}/>
                <div className="px-4 overflow-auto h-full max-h-custom custom-scrollBar py-6">
                    <FormikProvider value={formik}>
                        <form className={"w-full  flex flex-col justify-between"}>
                            <div>
                                <section className={"flex flex-col gap-y-[10px] mb-[30px]"}>
                                    <div className={"flex flex-col w-full h-full gap-y-6"}>
                                        <div className={"mb-0"}>
                                            <CustomSelect getFieldProps={formik.getFieldProps}
                                                          formikValue="period"
                                                          title={t('form.selects.period.title')} arr={periodArr}
                                                          existLabel={true}/>
                                        </div>
                                        <div className={"mb-0"}>
                                            <TextFieldCustom getFieldProps={formik.getFieldProps}
                                                             formikValue={'login'}
                                                             text={t('form.selects.referralLogin.subTitle')}
                                                             label={t('form.selects.referralLogin.title')}
                                                             placeholder={t('form.selects.referralLogin.placeholder')}/>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div
                                className={"w-full fixed bottom-[80px] px-4 left-0 bg-[var(--default-page-color)] pt-4"}>
                                <Button color={'light'}
                                        onClick={resetValues}
                                        className={"w-full !py-2.5 !text-sm !font-semibold border !border-[var(--border-color-block)] bg-transparent before:bg-transparent shadow-xs"}>
                                    {t('common.buttons.resetAll')}
                                </Button>
                            </div>
                            <ButtonsBottomBlockOfPage title1={t('common.buttons.cancel')}
                                                      title2={t('common.buttons.applyBtn')}
                                                      onClickBack={onClose}
                                                      type={'submit'}
                                                      continueFunc={formik.handleSubmit}
                            />
                        </form>
                    </FormikProvider>
                </div>
            </motion.div>
        </div>
    );
};